export const kpiData = [
  {
    id: 'total-energy',
    label: '今日总能耗',
    value: 12847.5,
    unit: 'kWh',
    change: -12.3,
    changeLabel: '较昨日',
    icon: 'ri-flashlight-line',
    color: 'green',
    sparkline: [45, 52, 48, 60, 55, 58, 62, 59, 65, 70, 68, 72, 75, 71, 78, 82, 80, 85, 88, 92, 90, 95, 98, 100],
  },
  {
    id: 'carbon-emission',
    label: '今日碳排放',
    value: 5.24,
    unit: '吨CO2',
    change: -8.7,
    changeLabel: '较昨日',
    icon: 'ri-leaf-line',
    color: 'green',
    sparkline: [30, 32, 28, 35, 33, 30, 32, 29, 31, 28, 26, 25, 27, 24, 22, 20, 21, 19, 18, 17, 16, 15, 14, 13],
  },
  {
    id: 'cost-saving',
    label: '本月节约费用',
    value: 86420,
    unit: '元',
    change: 23.5,
    changeLabel: '较上月',
    icon: 'ri-coins-line',
    color: 'green',
    sparkline: [20, 25, 30, 28, 35, 40, 38, 45, 50, 48, 55, 60, 58, 65, 70, 68, 75, 80, 78, 85, 90, 88, 95, 100],
  },
  {
    id: 'efficiency',
    label: '设备运行效率',
    value: 94.8,
    unit: '%',
    change: 2.1,
    changeLabel: '较上周',
    icon: 'ri-dashboard-line',
    color: 'blue',
    sparkline: [80, 82, 81, 85, 84, 86, 88, 87, 89, 90, 89, 91, 92, 91, 93, 94, 93, 95, 96, 95, 97, 96, 98, 99],
  },
  {
    id: 'active-devices',
    label: '在线设备数',
    value: 487,
    unit: '台',
    change: 0,
    changeLabel: '实时',
    icon: 'ri-server-line',
    color: 'blue',
    sparkline: [100, 100, 100, 99, 100, 100, 100, 99, 100, 100, 100, 100, 100, 99, 100, 100, 100, 100, 100, 100, 100, 99, 100, 100],
  },
  {
    id: 'alert-count',
    label: '待处理告警',
    value: 3,
    unit: '条',
    change: -2,
    changeLabel: '较1小时前',
    icon: 'ri-alarm-warning-line',
    color: 'red',
    sparkline: [8, 7, 8, 6, 7, 5, 6, 4, 5, 3, 4, 3, 2, 3, 2, 1, 2, 1, 0, 1, 0, 1, 0, 0],
  },
];

export const energyByType = [
  { name: '电力', value: 62, color: '#00D9A3' },
  { name: '天然气', value: 22, color: '#00B4D8' },
  { name: '蒸汽', value: 10, color: '#F59E0B' },
  { name: '水', value: 6, color: '#6366F1' },
];

export const energyByArea = [
  { name: '生产车间A', value: 35, color: '#00D9A3' },
  { name: '生产车间B', value: 28, color: '#00B4D8' },
  { name: '办公楼', value: 15, color: '#F59E0B' },
  { name: '仓储物流', value: 12, color: '#6366F1' },
  { name: '数据中心', value: 10, color: '#EC4899' },
];

export const hourlyEnergyData = [
  { hour: '00:00', value: 420 },
  { hour: '01:00', value: 380 },
  { hour: '02:00', value: 350 },
  { hour: '03:00', value: 340 },
  { hour: '04:00', value: 360 },
  { hour: '05:00', value: 400 },
  { hour: '06:00', value: 520 },
  { hour: '07:00', value: 680 },
  { hour: '08:00', value: 850 },
  { hour: '09:00', value: 920 },
  { hour: '10:00', value: 980 },
  { hour: '11:00', value: 1050 },
  { hour: '12:00', value: 890 },
  { hour: '13:00', value: 950 },
  { hour: '14:00', value: 1100 },
  { hour: '15:00', value: 1150 },
  { hour: '16:00', value: 1080 },
  { hour: '17:00', value: 920 },
  { hour: '18:00', value: 780 },
  { hour: '19:00', value: 650 },
  { hour: '20:00', value: 580 },
  { hour: '21:00', value: 520 },
  { hour: '22:00', value: 480 },
  { hour: '23:00', value: 450 },
];

export const weeklyCarbonData = [
  { day: '周一', actual: 5.8, target: 6.0 },
  { day: '周二', actual: 5.6, target: 6.0 },
  { day: '周三', actual: 5.2, target: 6.0 },
  { day: '周四', actual: 5.4, target: 6.0 },
  { day: '周五', actual: 5.1, target: 6.0 },
  { day: '周六', actual: 4.8, target: 5.5 },
  { day: '周日', actual: 4.5, target: 5.5 },
];

export const deviceStatus = [
  { id: 'DEV-001', name: '空压机 A1', area: '生产车间A', status: 'online', power: 45.2, efficiency: 96, runtime: 8760 },
  { id: 'DEV-002', name: '中央空调主机', area: '办公楼', status: 'online', power: 128.5, efficiency: 94, runtime: 7200 },
  { id: 'DEV-003', name: '冷却塔 B2', area: '生产车间B', status: 'warning', power: 32.1, efficiency: 78, runtime: 6540 },
  { id: 'DEV-004', name: '变压器 T1', area: '配电房', status: 'online', power: 520.0, efficiency: 99, runtime: 8760 },
  { id: 'DEV-005', name: '水泵 P3', area: '仓储物流', status: 'offline', power: 0, efficiency: 0, runtime: 4320 },
  { id: 'DEV-006', name: 'LED照明系统', area: '办公楼', status: 'online', power: 8.5, efficiency: 98, runtime: 4380 },
  { id: 'DEV-007', name: '服务器机柜', area: '数据中心', status: 'online', power: 65.3, efficiency: 92, runtime: 8760 },
  { id: 'DEV-008', name: '锅炉 H1', area: '生产车间A', status: 'online', power: 85.7, efficiency: 88, runtime: 7200 },
];

export const alerts = [
  {
    id: 1,
    level: 'warning',
    device: '冷却塔 B2',
    message: '运行效率低于阈值（78% < 80%），建议检查冷却水循环',
    time: '2分钟前',
    icon: 'ri-error-warning-line',
  },
  {
    id: 2,
    level: 'critical',
    device: '水泵 P3',
    message: '设备离线超过30分钟，请检查供电和网络连接',
    time: '15分钟前',
    icon: 'ri-close-circle-line',
  },
  {
    id: 3,
    level: 'info',
    device: '空压机 A1',
    message: 'AI优化建议：建议将运行时段调整至 22:00-06:00 以利用谷电优惠',
    time: '32分钟前',
    icon: 'ri-lightbulb-line',
  },
  {
    id: 4,
    level: 'warning',
    device: '生产车间B',
    message: '区域能耗较昨日同期上升 15%，超出正常波动范围',
    time: '1小时前',
    icon: 'ri-arrow-up-line',
  },
  {
    id: 5,
    level: 'info',
    device: '系统',
    message: '月度能耗报告已生成，本月节能率 12.3%',
    time: '2小时前',
    icon: 'ri-file-chart-line',
  },
];

export const carbonBreakdown = [
  { scope: '范围一：直接排放', value: 28, color: '#00D9A3' },
  { scope: '范围二：间接排放（电力）', value: 52, color: '#00B4D8' },
  { scope: '范围三：价值链排放', value: 20, color: '#F59E0B' },
];

export const monthlyTrend = [
  { month: '1月', energy: 385000, carbon: 158, cost: 320000 },
  { month: '2月', energy: 342000, carbon: 142, cost: 285000 },
  { month: '3月', energy: 368000, carbon: 151, cost: 305000 },
  { month: '4月', energy: 356000, carbon: 147, cost: 295000 },
  { month: '5月', energy: 412000, carbon: 168, cost: 340000 },
  { month: '6月', energy: 445000, carbon: 182, cost: 368000 },
  { month: '7月', energy: 468000, carbon: 192, cost: 385000 },
  { month: '8月', energy: 452000, carbon: 186, cost: 375000 },
  { month: '9月', energy: 398000, carbon: 164, cost: 330000 },
  { month: '10月', energy: 372000, carbon: 153, cost: 310000 },
  { month: '11月', energy: 358000, carbon: 148, cost: 298000 },
  { month: '12月', energy: 380000, carbon: 156, cost: 315000 },
];